<!--
 * @Date: 2023-12-29 11:13:07
 * @Author: jm
 * @LastEditTime: 2024-02-29 10:49:29
 * @LastEditors: jm
 * @FilePath: \funny_h5\src\components\HeaderBar.vue
 * @Description: 
-->
<template>
    <div class="bar_wrap" :style="{bottom:position+'%'}">
      <a
        @click="onChangeTabIndex(index)"
        v-for="(item, index) in list"
        class="bar_item"
        :href="item.path"
      >
        <div class="pic_con" v-if="currIdx == index">
          <img class="pic" :src="item.icon_select" />
        </div>
        <div class="pic_con" v-else>
          <img class="pic" :src="item.icon" alt="" />
        </div>
        <span
          class="text"
          :style="{ color: currIdx == index ? '#FF6464' : '#959595' }"
          >{{ item.text }}</span
        >
      </a>
    </div>
  </template>
  
  <script>
  import icon1 from "../assets/images/home.png";
  import icon2 from "../assets/images/history.png";
  import icon3 from "../assets/images/category.png";
  import icon4 from "../assets/images/about.png";
  import select1 from "../assets/images/home_select.png";
  import select2 from "../assets/images/history_select.png";
  import select3 from "../assets/images/category_select.png";
  import select4 from "../assets/images/about_select.png";
  export default {
    name: "HeaderBar",
    props: {
      active: {
        type: Number,
        required: true,
      },
      position:{
        type: Number,
        required: false,
        default:0
      }
    },
    data() {
      return {
        currIdx: 0,
        list: [
          {
            text: "HOME",
            icon: icon1,
            icon_select: select1,
            path: "home.html",
          },
          {
            text: "HISTORY",
            icon: icon2,
            icon_select: select2,
            path: "history.html",
          },
          {
            text: "CATEGORY",
            icon: icon3,
            icon_select: select3,
            path: "category.html",
          },
          {
            text: "ABOUT US",
            icon: icon4,
            icon_select: select4,
            path: "about.html",
          },
        ],
      };
    },
    mounted() {
      this.currIdx = this.active;
    },
    methods: {
      onChangeTabIndex(index) {
        this.currIdx = index;
        // router.replace({
        //     uri: `${this.list[index].path}`
        // })
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .bar_wrap {
    padding: 10px 0px;
    background: #303137;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 1080px;
    height: 190px;
    position: fixed;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    z-index: 99999999;
    .bar_item {
      width: 280px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #959595;
      .text {
        margin-top: 20px;
      }
      .pic_con {
        width: 80px;
        height: 80px;
        .pic {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  </style>